import { BarChart3, PackageSearch } from 'lucide-react';
import { Link } from 'react-router-dom';
import './css/OrderAnalytics.css';

const OrderAnalytics = () => (
  <div className="page-container">
    <div className="page-header">
      <h2 className="module-page-title"><BarChart3 aria-hidden="true" /> Analizy zamówień</h2>
      <p>Analizy biznesowe terminowości zamówień i dostaw materiałów.</p>
    </div>

    <div className="page-content">
      <div className="tiles-grid">
        <Link to="/management/order-analytics/winkhaus" className="tile-card module-tile">
          <span className="tile-icon module-tile-icon" aria-hidden="true"><PackageSearch strokeWidth={1.8} /></span>
          <h3 className="tile-title">Winkhaus</h3>
          <p className="tile-description">Opóźnienia, zmiany terminów, terminowość i rytm zamówień.</p>
        </Link>

        <Link to="/management/order-analytics/schuco" className="tile-card module-tile">
          <span className="tile-icon module-tile-icon" aria-hidden="true"><PackageSearch strokeWidth={1.8} /></span>
          <h3 className="tile-title">Schüco</h3>
          <p className="tile-description">Terminowość AVIS, zmiany terminów, OTIF i rytm zamówień.</p>
        </Link>
      </div>
    </div>
  </div>
);

export default OrderAnalytics;
